<section class="auth-page-shell">
  <div class="auth-page-bg">
    <div class="container auth-page-container">
      <div class="auth-card auth-card-signin">

        <div class="auth-form-panel">
          <div class="auth-form-heading">
              <img
              :src="$sideLogo"
              class="img-fluid mx-auto d-block w-200 w-md-150"
              alt=""
            />
          <p v-if="bosa_domain" class="fw-bold text-center mb-2 mt-4">Welcome to BOSA Connect <br>A civic engagement platform</p>

          </div>
           <h4 class="fw-bold mt-3 d-flex justify-content-center">Sign in </h4>

          <form class="auth-form" @submit.prevent="handleSubmit">

            <div class="auth-field">
              <label for="email" class="form-label">Email<span class="text-danger">*</span></label>
              <div class="auth-field-shell">
                <i class="bi bi-envelope auth-input-icon"></i>
                <input
                  type="email"
                  class="form-control"
                  placeholder="example@gmail.com"
                  id="email"
                  v-model="email"
                  required
                >
              </div>
            </div>

            <div class="auth-field">
              <div class="auth-label-row">
                <label for="password" class="form-label">Password<span class="text-danger">*</span></label>
              </div>
              <div class="auth-field-shell">
                <i class="bi bi-lock auth-input-icon"></i>
                <input
                  :type="passwordVisible ? 'text' : 'password'"
                  class="form-control"
                  id="password"
                  placeholder="Enter password"
                  v-model="password"
                  required
                >
                <button
                  type="button"
                  class="auth-eye-toggle"
                  @click="togglePasswordVisibility"
                  aria-label="Toggle password visibility"
                >
                  <i :class="passwordVisible ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                </button>
              </div>
            </div>
            <p class="auth-link d-flex justify-content-between align-items-center gap-2 w-100">
              <span>Forgot password?</span>
              <a :href="reset_url" class="text-info fw-500 text-end">Reset password</a>
            </p>



            <button type="submit" class="btn auth-submit-btn" :disabled="isSubmitting">
              <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              {{ isSubmitting ? 'Signing in...' : 'Sign in' }}
            </button>

            <p v-if="!workbook_domain" class="auth-switch-text">
              Don't have an account?
              <router-link to="/register" class="auth-link">Sign up</router-link>
            </p>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
